import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { GalleryActions } from 'src/app/gallery/state/gallery.actions';
import { MatDialogRef } from '@angular/material';
import { GalleryState } from 'src/app/gallery/state/gallery.state';
import { Observable, Subject } from 'rxjs';
import { GalleryViewMode } from 'src/app/gallery/models/gallery-view-mode.enum';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { UserProfileModel } from 'src/app/auth/models/user-profile.model';
import { DialogActions } from '../../state/dialog.actions';

@Component({
  selector: 'app-import-model-dialog',
  templateUrl: './import-model-dialog.component.html',
  styleUrls: ['./import-model-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImportModelDialogComponent implements OnInit, OnDestroy {
  @Select(GalleryState.getViewMode)
  viewMode$: Observable<GalleryViewMode>;

  @Select(GalleryState.getLoading)
  loading$: Observable<boolean>;

  @Select(GalleryState.getSearchResults)
  results$: Observable<BookmarkModel[]>;

  @Select(AuthState.isPremiumUser)
  isPremiumUser$: Observable<boolean>;

  ngUnsubscribe = new Subject();

  constructor(
    private store: Store,
    private dialogRef: MatDialogRef<ImportModelDialogComponent>,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.results$.subscribe(results => {
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy() {
    this.store.dispatch(new GalleryActions.ClearResults());

    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  handleSelect(bookmark: BookmarkModel) {
    if (!bookmark.premium || this.store.selectSnapshot(AuthState.isPremiumUser)) {
      this.store.dispatch(new GalleryActions.SelectBookmark(bookmark));
      this.dialogRef.close(bookmark);
    } else {
      this.store.dispatch(new DialogActions.OpenPremiumContent());
    }
  }
}
